













































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Const } from '@/const';
import { Document } from '@/model/document2/document';
import { FileHelper } from '@/helper/fileHelper';
import { NameHelper } from '@/helper/nameHelper';
import { LogHelper } from "@/helper/logHelper";
import { ExcelHelper } from '@/helper/excelHelper';
import { InsertionData } from "@/model/document2/insertionData/insertionData";
import { InsertionHelper } from '@/helper/insertionHelper';
import { JsonHelper } from "@/helper/jsonHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { CookieHelper } from "@/helper/cookieHelper"
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { CloudHelper } from "@/helper/cloudHelper";
import { RequestHelper } from "@/helper/requestHelper";
import platform from '@/helper/platform';

import { CloudOperation } from '@/cloudOperation/cloudOperation';

import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import LeftController from "./leftController/leftController.vue";
// import Configuration from "./resources/configuration.vue";
import ChangeNameModal from "./cloudModal/changeNameModal.vue";
import DeleteModal from "./cloudModal/deleteModal.vue";
import LogoutModal from "./cloudModal/logoutModal.vue";
import TimeoutModal from "./cloudModal/timeoutModal.vue";
import DeletedAccountModal from "./cloudModal/deletedAccountModal.vue";
import MyPageModal from "./cloudModal/myPageModal.vue";
import ChangeMailModal from "./cloudModal/changeMailModal.vue";
import ChangePasswordModal from "./cloudModal/changePasswordModal.vue";
import CapacityModal from "./cloudModal/capacityModal.vue";
import InputMail from "../signIn/inputMail/inputMail.vue";
import InputPassword from "../signIn/inputPassword/inputPassword.vue";
import License from "../top2/mainContents/license/license.vue";
import SignInAlertModal from "../sns/signInAlertModal/signInAlertModal.vue";
import { CloudAccount } from "@/cloudAccount/cloudAccount";
import SelectExcelSheetModal from "@/commonComponents/alertModal/selectExcelSheetModal/selectExcelSheetModal.vue";
import ConfirmOverrideModal from './cloudModal/confirmOverrideModal.vue';

@Component({
    components: {
        LoadingScreen,
        LeftController,
        //   Configuration
        ChangeNameModal,
        DeleteModal,
        LogoutModal,
        TimeoutModal,
        DeletedAccountModal,
        MyPageModal,
        ChangeMailModal,
        ChangePasswordModal,
        CapacityModal,
        InputMail,
        InputPassword,
        License,
        SignInAlertModal,
        SelectExcelSheetModal,
        ConfirmOverrideModal
    }
})
export default class Cloud extends Vue {

    cloud = "";
    beforeCloud = "";
    name = "";
    mail = "";
    isError = false;
    errorMessages = new Array();
    totalSize = 0;
    errorTitle = "";
    errorMessage = "";

    changeNameModalShow = false;
    deleteModalShow = false;
    logoutModalShow = false;
    timeoutModalShow = false;
    isDeletedAccountModal = false;
    capacityModalShow = false;
    myPageModalShow = false;
    changeMailModalShow = false;
    changePasswordModalShow = false;
    inputMailShow = false;
    inputPasswordShow = false;
    isVisible = true;
    loading = false;
    isLicense = false;
    isFolder = false;
    isSignInAlert = false;

    messageJsonData = {onDoCommand : "", name: "", value: "", fileType: ""};

    loadingTitle = "読み込み中";
    loadingMessage = "読み込んでいます…";

    public get cloudAccount() : CloudAccount
    {
      	return this.$store.getters.cloudAccount;
    }

    @Watch("cloudAccount.isSignIn")
        changeIsSignIn(){
            if(!this.cloudAccount.isSignIn && this.cloudAccount.signOutType == 2 && !this.isDeletedAccountModal){
                this.timeoutModalShow = true;
                this.cloudAccount.signOutType = 3;
            }
        }

    private get iframeURL(){
        var url = Const.IFRAME_URL_BASE + "cloud/index.html";
        return url;
    }

    mounted() {
        this.cloudAccount.toGo = "Cloud";

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }

        if(!CookieHelper.hasItem("isLeftControllerVisible")){
            this.isLeftControllerVisible = true;
        }else{
            this.isLeftControllerVisible = CookieHelper.getItem("isLeftControllerVisible")
        }

        if(!this.cloudAccount.isSignIn){
            this.isSignInAlert = true;
            return;
        }

        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }
            this.loadAccount();
        })

        window.addEventListener("message", this.messageEvent);

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);
    }

    private destroyed(){
        window.removeEventListener("message", this.messageEvent);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");
    }

    private messageEvent(message){
        DebugHelper.trace(message.data);
        if(!JsonHelper.isJSON(message.data)){ return; }
        var jsonData = JSON.parse(message.data);
        if(jsonData.onDoCommand != void 0 && jsonData.onDoCommand != "activeEvent"){
            this.messageJsonData = jsonData;
        }
        DebugHelper.trace(jsonData);

        if(jsonData.onDoCommand !== void 0){
            if(jsonData.onDoCommand == "activeEvent"){
                CloudHelper.cloudSignOutTimer(this.cloudAccount);
            }
            else if(this.messageJsonData.onDoCommand == "openMenu"){
                this.isVisible = true;
            }
            else if(this.messageJsonData.onDoCommand == "名前変更"){
                this.isFolder = this.messageJsonData.fileType == "folder";
                this.name = this.messageJsonData.name;
                this.changeNameModalShow = true;
            }
            else if(this.messageJsonData.onDoCommand == "削除"){
                this.deleteModalShow = true;
            }
            else if(this.messageJsonData.onDoCommand == "新規フォルダ作成"){
                this.isFolder = true;
                this.name = "";
                this.changeNameModalShow = true;
            }
            else if(this.messageJsonData.onDoCommand == "アカウント管理"){
                this.openMyPage();
            }
            else if(this.messageJsonData.onDoCommand == "loading"){
                this.loading = this.messageJsonData.value == "true" ? true : false;
            }
            else if(this.messageJsonData.onDoCommand == "unSelect"){
                this.loading = false;
                this.cloud = this.beforeCloud;
            }
            else if(this.messageJsonData.onDoCommand == "setCloud"){
                this.beforeCloud = this.messageJsonData.value;
                this.cloud = this.messageJsonData.value;
            }
            else if(this.messageJsonData.onDoCommand == "setToken"){
                let value : any = this.messageJsonData.value;
                CookieHelper.setItem("accessToken", value.accessToken);
                CookieHelper.setItem("refreshToken", value.refreshToken);
                CookieHelper.setItem("accessLimit", value.accessLimit);
                CookieHelper.setItem("refreshLimit", value.refreshLimit);
            }
            else if(this.messageJsonData.onDoCommand == "setTotalSize"){
                this.totalSize = Number(this.messageJsonData.value);
            }
            else if(this.messageJsonData.onDoCommand == "labelyasanError"){
                let value : any = this.messageJsonData.value;
                this.errorTitle = String(value.title);
                this.errorMessage = String(value.message);
                this.capacityModalShow = true;
                this.loading = false;
            }
            else if(this.messageJsonData.onDoCommand == "formatError"){
                let value : any = this.messageJsonData.value;
                this.errorTitle = String(value.title);
                this.errorMessage = String(value.message);
                this.capacityModalShow = true;
                this.loading = false;
            }
            else if(this.messageJsonData.onDoCommand == "uploadDone"){
                this.uploadDone();
            }
            else if(this.messageJsonData.onDoCommand == "redirect"){
                this.redirect(this.messageJsonData);
            }
            else if(this.messageJsonData.onDoCommand == "reload"){
                this.reloadIframe();
            }
            else if(this.messageJsonData.onDoCommand == "gapiLoading"){
                this.gapiLoading();
            }
            else if(this.messageJsonData.onDoCommand == "timeout"){
                this.timeoutModalShow = true;
                this.cloudAccount.isSignIn = false;
                this.cloudAccount.signOutType = 3;
            }
            else if(this.messageJsonData.onDoCommand == "deletedAccount"){
                // deletedAccountのモーダルを出す
                this.isDeletedAccountModal = true;
                this.cloudAccount.isSignIn = false;
                this.cloudAccount.signOutType = 1;
            }
            else if(this.messageJsonData.onDoCommand == "openFile"){
                // openMode出なければ処理しない
                if(this.cloudOperation.mode == "save"){ return; }
                if(!this.isReadTable && this.messageJsonData.fileType == "aly"){
                // if(this.messageJsonData.fileType == "aly"){
                    DebugHelper.trace(this.messageJsonData);
                    var document = Document.createFromJsonData(this.messageJsonData.value);
                    FileHelper.decodeDocumentImage(document);
                    document.updateHash();
                    this.loadDocument(document, this.messageJsonData.name);
                }
                else if(!this.isReadTable && this.messageJsonData.fileType == "aly2")
                {
                    DebugHelper.trace(this.messageJsonData);
                    var buf = FileHelper.convertBinaryStringToBuffer(this.messageJsonData.value);
                    var doc = FileHelper.loadDocument(buf);
                    if(doc != null) this.loadDocument(doc, this.messageJsonData.name);
                }
                // else{
                else if(this.isReadTable && (this.messageJsonData.fileType == "excel" || this.messageJsonData.fileType == "csv")){
                    // 差し込み時のcsv,xlsxを取得する時
                    DebugHelper.trace(this.messageJsonData);

                    if(this.messageJsonData.fileType == "excel"){
                        var base64 = this.messageJsonData.value;
                        var rawData = decodeURIComponent(escape(atob(base64)));
                        var rawLength = rawData.length;
                        var uint8Array = new Uint8Array(new ArrayBuffer(rawLength));
                        for(var i = 0; i < rawLength; ++i)
                        {
                            uint8Array[i] = rawData.charCodeAt(i);
                        }
                        DebugHelper.trace(base64);
                        DebugHelper.trace(atob(base64));
                        DebugHelper.trace(rawData);
                        DebugHelper.trace(uint8Array);
                        DebugHelper.trace(uint8Array.buffer);
                        let buf = uint8Array.buffer as ArrayBuffer;
                        ExcelHelper.xlsxBinaryToJsonStringWithSelectSheet(buf, (sheetNames : string[], callback : (index : number) => void) =>
                        {
                            var modal = this.$refs.selectExcelSheetModal as SelectExcelSheetModal;
                            modal.open(sheetNames, (button : string, index : number) =>
                            {
                                if(button == "ok")
                                {
                                    callback(index);
                                }
                            });
                        }, (result) =>
                        {
                            DebugHelper.trace(result);
                            this.onFileRead(result, "binary");
                        }, () =>
                        {
                            DebugHelper.trace("import excel error");
                        });
                    }else if(this.messageJsonData.fileType == "csv"){

                        this.onFileRead(this.messageJsonData.value, "textBinary");
                    }
                }
            }
            else if(this.messageJsonData.onDoCommand == "ログアウト"){
                this.logoutModalShow = true;
            }
            else if(this.messageJsonData.onDoCommand == "confirm_file_overridden")
            {
                // ローディング解除
                this.loading = false;
                // ファイルの上書き確認
                let filename = this.messageJsonData.value;
                // 上書きをするか選択する
                let modal = this.$refs.confirmOverrideModal as ConfirmOverrideModal;
                modal.open(filename, result =>
                {
                    if(result)
                    {
                        // 上書き保存する
                        this.loading = true;
                        let buf = FileHelper.convertDocumentToSaveBuffer(this.currentDocument);
                        if(buf == null) return;
                        let bs = FileHelper.convertBufferToBinaryString(buf);
                        let ifrm = (<any>this.$refs.iframe).contentWindow;
                        ifrm.postMessage(JSON.stringify({
                            onDoCommand : "saveFile",
                            name : filename,
                            value : { fileType : "application/zip", binaryData : bs },
                            override : true
                        }), "*");
                    }
                });
            }
            // else if(this.messageJsonData.onDoCommand == "loginError"){
            //     (<HTMLElement>this.$refs[this.cloud]).style.backgroundColor = "";
            //     this.cloud = "";
            // }
        };
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(paramParent : any)
    {
        try
        {
            let command : string = paramParent.command;
            let parameter : any = paramParent.parameter;

            if(command == "process_login_message")
            {
                // ログイン中のメッセージ処理
                DebugHelper.trace("process_login_message");
                let message = parameter.message;
                let messageObj = JSON.parse(message);
                let cmd = messageObj.onDoCommand;
                DebugHelper.trace("cmd: " + cmd);
                if(cmd == "redirect")
                {
                    // リダイレクト
                    DebugHelper.trace("Electron, process redirect.");
                    this.redirect(messageObj);
                }
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private onDoCommand(command: string, param: any){
        if(command == "changeMail"){
            this.myPageModalShow = false;
            this.changeMailModalShow = true;
        }
        else if(command == "changePassword"){
            this.myPageModalShow = false;
            this.changePasswordModalShow = true;
        }
        else if(command == "cansel"){
            this.changeMailModalShow = false;
            this.changePasswordModalShow = false;
            this.myPageModalShow = true;
        }
        else if(command == "saveMail"){
            this.saveMail(param);
        }
        else if(command == "savePassword"){
            this.savePassword(param);
        }
        else if(command == "forgot"){
            this.changePasswordModalShow = false;
            this.isError = false;
            this.errorMessages = new Array();
            this.inputMailShow = true;
        }
        else if(command == "sendMail"){
            this.sendMail(param);
        }
        else if(command == "reregistrationPassword"){
            this.reregistrationPassword(param);
        }
        else if(command == "returnPage"){
            this.inputMailShow = false;
            this.inputPasswordShow = false;
        }
        else if (command === "changeNeedsRecommend") {
            this.changeNeedsRecommend(param);
        }
    }

    accountForm = {
        needsRecommend: ""
    };

    loadAccount() {
        const params = {
            action: "show",
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            platformId : String(platform.id),
        };
        RequestHelper.post("questionnaire", params, (response) => {
            const json = JSON.parse(response);
            DebugHelper.trace(json);
            if (json.status) {
                DebugHelper.trace("アンケート情報を取得できませんでした。");
                return;
            }
            this.accountForm = {
                needsRecommend: json.data.needsRecommend ? "on" : ""
            };
        }, () => {
            DebugHelper.trace("アンケート情報を取得できませんでした。");
        });
    }

    changeNeedsRecommend(needsRecommend: boolean) {
        const payload = {
            action: "change_needs",
            authorizationToken : CookieHelper.getItem("authorizationToken"),
            accessToken : CookieHelper.getItem("accessToken"),
            platformId : String(platform.id),
            needsRecommend: needsRecommend ? "1" : "0"
        };
        RequestHelper.post("questionnaire", payload, res => {
            const json = JSON.parse(res);
            if (json.status) {
                alert(json.message.join("\n"));
                return;
            }
            const msg = needsRecommend ? "メールの配信を有効化しました。" : "メールの配信を無効化しました。";
            alert(msg);
        }, ()=> {
            DebugHelper.trace("配信設定を保存できませんでした。");
        });
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }

    public get cloudOperation() : CloudOperation
    {
      	return this.$store.getters.cloudOperation;
    }

    isReloaded = false;
    private reloadIframe(){
        if(this.isReloaded){ return; }
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.location.reload(true);

        this.isReloaded = true;
    }

    private gapiLoading(){
        if(this.isReloaded){
            this.selectCloud("googleDrive");
        }
    }

    loadIframe(){
        var command = { onDoCommand : "setColor", color : this.userConfigColor, backgroundColor : this.$store.getters.userConfigColors.backgroundColor };
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(command), "*");

        if(!this.cloudAccount.isSignIn){ return; }

        let cloud = "labelyasan";
        if(this.isReadTable){
            cloud = "";
        }

        this.setCloudMode();

        if(!this.isReloaded){
            this.selectCloud(cloud);
        }
    }

    private setCloudMode(){
        var command = {
            onDoCommand : "setCloudMode",
            value : this.cloudOperation.mode
        };
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(command), "*");
    }

    private redirect(messageJsonData){
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(messageJsonData), "*");
    }

    private get isReadTable(){
        return this.cloudOperation.returnPage == "/SelectInsertionDesign" || this.cloudOperation.returnPage == "/InsertionEditor";
    }

    private selectCloud(cloud: string){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            this.loading = cloud != "" ? true : false;
            this.beforeCloud = this.cloud;
            this.cloud = cloud;

            var command = {};

            if(cloud == "labelyasan"){
                let authorizationToken = CookieHelper.hasItem("authorizationToken") ? CookieHelper.getItem("authorizationToken") : "";
                let accessToken = CookieHelper.hasItem("accessToken") ? CookieHelper.getItem("accessToken") : "";
                let refreshToken = CookieHelper.hasItem("refreshToken") ? CookieHelper.getItem("refreshToken") : "";
                command = {
                    onDoCommand : "selectCloud",
                    cloud : cloud,
                    authorizationToken : authorizationToken,
                    accessToken : accessToken,
                    refreshToken : refreshToken,
                    platformId : String(platform.id),
                    base : Const.API_URL_BASE
                }
            }
            else{
                command = {
                    onDoCommand : "selectCloud",
                    cloud : cloud
                }
            }

            var ifrm = (<any>this.$refs.iframe).contentWindow;

            if(process.env.VUE_APP_POP_UP_AVOIDANCE === 'yes' && !UserAgentHelper.isElectron()){
                ifrm.selectCloud(JSON.stringify(command));
            }
            else{
                ifrm.postMessage(JSON.stringify(command), "*");
            }

            this.closeSubController();

        })
    }

    isLeftControllerVisible : boolean = true;

    closeSubController(){
        this.isVisible = false;
        CookieHelper.setItem("isLeftControllerVisible" , false)
    }

    openSubController(){
        this.isVisible = true;
        CookieHelper.setItem("isLeftControllerVisible" , true)
    }

    openMyPage(){
        // if(!CookieHelper.hasItem("authorizationToken") || !CookieHelper.hasItem("accessToken")){
        //     // 確認用
        //     this.myPageModalShow = true;
        //     return;
        // }

        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id)
            }

            RequestHelper.post("get_user_detail", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    this.isError = false;
                    this.mail = res.data.mail;
                    this.myPageModalShow = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    saveMail(mail){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id),
                mail : mail
            }

            RequestHelper.post("get_user_edit_mail", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    this.isError = false;
                    this.changeMailModalShow = false;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    savePassword(pass){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            var param = {
                authorizationToken : CookieHelper.getItem("authorizationToken"),
                accessToken : CookieHelper.getItem("accessToken"),
                platformId : String(platform.id),
                oldPassword : pass.oldPassword,
                password : pass.password,
                rePassword : pass.rePassword
            }

            RequestHelper.post("get_user_edit_password", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    this.isError = false;
                    this.changePasswordModalShow = false;
                    this.myPageModalShow = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    // パスワード忘れた時のワンタイムパス発行
    private sendMail(param){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.isDeletedAccountModal = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            RequestHelper.post("send_reset_onetime", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    CookieHelper.setItem("certificationToken", res.data.certificationToken);
                    this.isError = false;
                    this.errorMessages = new Array();
                    this.inputMailShow = false;
                    this.inputPasswordShow = true;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    // ワンタイムパスでパスワードの再設定
    private reregistrationPassword(param){
        CloudHelper.checkAccessToken((checkRes) => {
            if(checkRes){
                if(checkRes == "timeout"){
                    this.timeoutModalShow = true;
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 3;
                }
                else if(checkRes == "deletedAccount"){
                    // アカウントが消えているモーダルを出す
                    this.cloudAccount.isSignIn = false;
                    this.cloudAccount.signOutType = 1;
                }
                DebugHelper.trace(checkRes);
                return;
            }

            RequestHelper.post("reset_password", param, (response) => {
                var res : any = JSON.parse(response);
                DebugHelper.trace(res);
                if(res.message.length > 0){
                    this.isError = true;
                    this.errorMessages = new Array();
                    for(var i = 0; i < res.message.length; i++){
                        this.errorMessages.push({index: i, message: res.message[i]});
                    }
                }
                else{
                    CookieHelper.setItem("authorizationToken", res.data.authorizationToken);
                    CookieHelper.setItem("accessToken", res.data.accessToken);
                    CookieHelper.setItem("refreshToken", res.data.refreshToken);
                    CookieHelper.setItem("accessLimit", res.data.accessLimit);
                    CookieHelper.setItem("refreshLimit", res.data.refreshLimit);
                    this.isError = false;
                    this.errorMessages = new Array();
                    this.inputPasswordShow = false;
                }
            }, () => {
                DebugHelper.trace("エラー");
            });
        })
    }

    logout(){
        CloudHelper.signOut(this.cloudAccount, 1);

        this.$nextTick(() => {
            this.returnPage();
        })
    }

    private get cloudType(){
        var type = 0;
        if(this.cloud == "labelyasan"){ type = 1; }
        else if(this.cloud == "googleDrive"){ type = 2; }
        else if(this.cloud == "dropbox"){ type = 3; }
        else if(this.cloud == "oneDrive"){ type = 4; }
        return type;
    }

    private uploadDone(){
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : this.cloudType
        };

        LogHelper.sendLog("1000", logValue);
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }

    private get userConfigBackgroundColor(){
        var style = {
            background: this.$store.getters.userConfigColors.backgroundColor,
        };
        return style;
    }

    deleteData(){
        this.loading = true;
        var command = {
            onDoCommand : "delete"
        };
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(command), "*");
    }

    changeNameData(name){
        this.loading = true;

        var buf = FileHelper.convertDocumentToSaveBuffer(this.currentDocument);
        if(buf == null) return;
        var bs = FileHelper.convertBufferToBinaryString(buf);

        var command;
        if(this.messageJsonData.onDoCommand != "saveFile")
        {
            command = {
                onDoCommand : this.messageJsonData.onDoCommand,
                name : name
            };
        }
        else
        {
            var buf = FileHelper.convertDocumentToSaveBuffer(this.currentDocument);
            if(buf == null) return;
            var bs = FileHelper.convertBufferToBinaryString(buf);
            command = {
                onDoCommand : this.messageJsonData.onDoCommand,
                name : name,
                value : { fileType : "application/zip", binaryData : bs }
            };
        }
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(command), "*");
    }

    returnPage(){
        this.$router.push(this.cloudOperation.returnPage);
    }

    goSignIn(){
        this.$router.push("/SignIn");
    }

    saveButtonClick(){
        // 開いた時のファイル名があればそれを使う
        var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
        fileName += this.currentDocument.useInsertion ? Const.INSERTION_FILE_EXTENSION : Const.PROJECT_FILE_EXTENSION;

        this.messageJsonData.onDoCommand = "saveFile";

        this.name = fileName;
        this.isFolder = false;

        this.changeNameModalShow = true;
    }

    // ドキュメントのロード
    private loadDocument(document : Document, fileName : string = "")
    {
        // ファイル名保持
        document.openedFileName = fileName;

        var applicationState = this.$store.getters.applicationState;

        var logValue = {
            productId : document.productId,
            code : document.paperCode,
            cloud: this.cloudType
        };
        //ファイルを開いたときにそのファイルの品番をログで送る
        LogHelper.sendLog("100" , logValue);

        if(applicationState.flowMode == 2)
        {
            // 差し込みドキュメントから連番レイヤーを削除する
            InsertionHelper.removeNumberLayerFromDocument(document);
            // 差し込みドキュメントセット
            this.$store.getters.userConfig.insertionDocument = document;

            // 新規ドキュメント作成
            var newDocument = Document.createFromDocument(document);
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", newDocument);

            // アプリフローが差し込みの読み込みだった場合はデザイン選択に遷移
            this.$router.push("/SelectInsertionDesign");
        }
        else if(document.useInsertion)
        {
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", document);

            // アプリフローを差し込みにする
            applicationState.flowMode = 3;

            // 差し込みに遷移
            this.$router.push("/InsertionEditor");
        }
        else
        {
            // ドキュメントを差し替える
            this.$store.dispatch("setDocument", document);

            // アプリフローを通常にする
            applicationState.flowMode = 0;

            // レイアウトエディターに遷移
            this.$router.push("/LayoutEditor");
        }
    }

    private onFileRead(text : string, readType : string)
    {
        if(readType == "binary")
        {
            // xlsx読み込み
            var loadedData = InsertionData.createFromXlsx(text, this.currentDocument.insertionData);
            this.currentDocument.insertionData = loadedData;
        }
        else
        {
            // csv読み込み
            var loadedData = InsertionData.createFromCsv(text, this.currentDocument.insertionData);
            this.currentDocument.insertionData = loadedData;
        }

        if(this.currentDocument.insertionData.isFirstRowAsColumnName && this.currentDocument.insertionData.getRowDataCount() <= 1)
        {
            // 1行目を列名にするが有効で、行数が1の場合は行がなくなってしまうので、1行目を列名にするをオフにする
            this.currentDocument.insertionData.isFirstRowAsColumnName = false;
        }

        // カレントを 0,0 に戻す
        this.currentDocument.selectedInsertionRow = 0;
        this.currentDocument.selectedInsertionColumn = 0;
        this.currentDocument.selectedInsertionWholeColumn = -1;

        this.applyInsertionToFirstDesign();

        this.$router.push("/InsertionEditor");
    }

    // 入力情報を最初のデザインに反映させる
    private applyInsertionToFirstDesign()
    {
        InsertionHelper.applyInsertionToFirstDesign(this.currentDocument);
    }

    unicode2buffer(str: string){

        var n = str.length,
            idx = -1,
            byteLength = 512,
            bytes = new Uint8Array(byteLength),
            i, c, _bytes;

        for(i = 0; i < n; ++i){
            c = str.charCodeAt(i);
            if(c <= 0x7F){
                bytes[++idx] = c;
            } else if(c <= 0x7FF){
                bytes[++idx] = 0xC0 | (c >>> 6);
                bytes[++idx] = 0x80 | (c & 0x3F);
            } else if(c <= 0xFFFF){
                bytes[++idx] = 0xE0 | (c >>> 12);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3F);
                bytes[++idx] = 0x80 | (c & 0x3F);
            } else {
                bytes[++idx] = 0xF0 | (c >>> 18);
                bytes[++idx] = 0x80 | ((c >>> 12) & 0x3F);
                bytes[++idx] = 0x80 | ((c >>> 6) & 0x3F);
                bytes[++idx] = 0x80 | (c & 0x3F);
            }
            if(byteLength - idx <= 4){
                _bytes = bytes;
                byteLength *= 2;
                bytes = new Uint8Array(byteLength);
                bytes.set(_bytes);
            }
        }
        idx++;

        var result = new Uint8Array(idx);
        result.set(bytes.subarray(0,idx),0);

        return result.buffer;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }

    private encodeHTMLForm(data : any){
        var params = new Array();

        for(var name in data){
            var value = data[name];
            var param = encodeURIComponent( name ) + '=' + encodeURIComponent( value );

            params.push( param );
        }
        return params.join( '&' ).replace( /%20/g, '+' );
    }
}
